import React, { useState } from 'react';
import PropTypes from 'prop-types';
import style from './IdCardPrinterBoard.module.sass';

const AddPrinterForm = ({ onAddPrinter, disabled }) => {
  const [serialNumber, setSerialNumber] = useState('');
  const [printerLetter, setPrinterLetter] = useState('');

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!serialNumber.trim()) return;
    onAddPrinter(serialNumber.trim(), printerLetter.trim());
    setSerialNumber('');
    setPrinterLetter('');
  };

  return (
    <form className={style.addForm} onSubmit={handleSubmit}>
      <input
        type="text"
        className="form-control"
        placeholder="Serial #"
        value={serialNumber}
        onChange={(event) => setSerialNumber(event.target.value)}
      />
      <input
        type="text"
        className="form-control"
        placeholder="Letter"
        maxLength={10}
        value={printerLetter}
        onChange={(event) => setPrinterLetter(event.target.value)}
      />
      <button type="submit" className="btn btn-primary btn-sm" disabled={disabled || !serialNumber.trim()}>
        + Add Printer
      </button>
    </form>
  );
};

AddPrinterForm.propTypes = {
  onAddPrinter: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default AddPrinterForm;
